import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../utils/apiClient";
import useLocalStorage from "../helpers/localStorageHook";
import DateField from "../shared/DateField";

export default function ReportsBar({ reportsCount=0, startDate, setStartDate, endDate, setEndDate, handleDownloadReport, showDropDown, setShowDropDown }) {

    


    const navigate = useNavigate();
    const handleClicDropDown = () => {
        setShowDropDown(!showDropDown)
    }


    

    const [reportsTypes, setReportsTypes] = useState([
        {value:'/b-reports/requests-summary',label:'تقرير الطلبات'},
        {value:'/b-reports/units-detailed-requests',label:'تقرير الطلبات المفصل'},
        {value:'/b-reports/units-expense-detailed',label:'تقرير تفاصيل المصروفات'},
        {value:'/b-reports/property-performance',label:'تقرير اداء العقارات'},
        {value:'/b-reports/units-preventive-visits',label:'تقرير جدول الصيانة الوقائية القادمة'},
    ]);
    


    return (
        <div className="rounded-[8px] bg-white h-[56px] flex flex-nowrap">
             <div className="flex-auto leading-[50px] h-[50px] text-grey-900 font-[500] text-[20px] ps-[10px] pe-[25px] mt-[3px] border-e-[1px] border-e-grey-200 whitespace-nowrap">
                كل التقارير
                <span className="text-orange"> {`(${reportsCount})`}</span>
             </div>
             <div className="w-[430px] relative ps-[8px] pe-[8px]">
                {/* <input type="text" className="outline-none leading-[50px] h-[50px] mt-[3px] w-full text-[18px] text-grey-600 font-[400]" />
                <span className="absolute end-[35px] top-[16px] w-[24px] h-[24px] select-none cursor-pointer !bg-center !bg-no-repeat" style={{background:"url('/assets/images/search-icon.svg')"}}></span> */}
             <div className="inline-block align-middle text-[16px] text-grey-900 font-[500] leading-[56px] me-[8px]">
             تصدير التقرير عن فترة
             </div>
            <DateField value={startDate} error={''} errorMessage={''} translateError={true} onChange={(date)=>{ setStartDate(date)}} inlineSmall />
             <div className="inline-block align-middle text-[16px] text-grey-900 font-[500] leading-[56px] mx-[8px]">
             الى
             </div>
            <DateField value={endDate} error={''} errorMessage={''} translateError={true} onChange={(date)=>{ setEndDate(date)}} inlineSmall />
             </div>
              <div className={`w-[258px] rounded-e-[8px] bg-blue cursor-pointer text-center text-white leading-[56px] text-[18px] font-[700] relative pe-[52px] ${!startDate || !endDate ? '!opacity-50 pointer-events-none' : ''}`} onClick={()=>handleClicDropDown()}>

                <div className="w-[210px] px-[15px] text-start overflow-hidden text-ellipsis whitespace-nowrap select-none">
                    اختر نوع التقرير
                </div>
                <span className="w-[22px] h-[32px] absolute top-[12px] end-[10px]" style={{background: "url('/assets/images/drop-arrow.svg')"}}></span>
                {showDropDown && <div className="absolute z-[100] shadow-[0px_25px_35px_0px_rgba(0,0,0,0.03)] top-[56px] left-[0px] rounded-b-[8px] w-[258px] bg-white border border-grey-300 py-[8px] px-[12px] text-center text-grey-600 font-[500] text-[14px]">
                    <ul>
                        {reportsTypes && Array.isArray(reportsTypes) && reportsTypes?.length > 0 
                            ? reportsTypes?.map((reportType,index)=>{
                                return (<li key={'reportDrop-'+reportType?.value} className={`relative text-start py-[4px] cursor-pointer select-none font-[500] text-[15px] text-grey-600 ${index !== reportsTypes?.length-1 ? 'border-b-[1px] border-b-grey-200' : ''}`} onClick={()=>handleDownloadReport(reportType?.value,reportType?.label)}>
                                    <div className="hover:bg-[#5381B233] leading-[40px] px-[8px]">
                                        {reportType?.label}
                                        <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute top-[50%] end-[10px] mt-[-4px]">
                                            <path d="M4.2774 8.5575C4.4674 8.5575 4.6574 8.4875 4.8074 8.3375C5.0974 8.0475 5.0974 7.5675 4.8074 7.2775L1.8074 4.2775L4.8074 1.2775C5.0974 0.9875 5.0974 0.5075 4.8074 0.2175C4.5174 -0.0725 4.0374 -0.0725 3.7474 0.2175L0.217402 3.7475C-0.072598 4.0375 -0.072598 4.5175 0.217402 4.8075L3.7474 8.3375C3.8974 8.4875 4.0874 8.5575 4.2774 8.5575Z" fill="#94A3B8"/>
                                        </svg>
                                    </div>
                                    </li>)
                            })
                            : <li></li>}
                    </ul>
                </div>}
             </div>
        </div>
    )
}